<template>
    <div class="popup" :class="{'expanded': expanded || isMobile, 'contact-form' : contactForm}">
        <div class="title">
            {{title}}
            <i class="material-icons" @click="$emit('close')">close</i>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        expanded: Boolean,
        title: String,
        contactForm: Boolean,
    },
    data() {
        return {
            isMobile:
                navigator.userAgent.match(/Android/i) ||
                navigator.userAgent.match(/webOS/i) ||
                navigator.userAgent.match(/iPhone/i) ||
                navigator.userAgent.match(/iPad/i) ||
                navigator.userAgent.match(/iPod/i) ||
                navigator.userAgent.match(/BlackBerry/i) ||
                navigator.userAgent.match(/Windows Phone/i),
        }
    },
}
</script>

<style scoped lang="scss">
.popup {
    background-color: $background;
    padding: 30 * $rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 1000 * $rem;
    border-radius: 5 * $rem;
    height: 50vh;
    transition: all 0.3s ease-out;
    overflow-y: auto;


    &.contact-form {
        height: 40.6667rem  !important;
        min-width: 28rem !important;
        overflow: hidden;
        background: #fff;

        form {
            $color: rgb(126, 126, 126);
            text-align: center;
            & > div {
                margin-bottom: 1rem;
                label {
                    width: 100%;
                    /deep/ span:not(.focused) {
                        color: $color;
                    }
                }

                input, textarea {
                    width: 100%;
                    resize: none;
                }

                .select-wrapper {
                    width: 100%;
                }

                textarea::placeholder {
                    color: $color;
                }
            }
            .btn {
                min-height: 3.3rem;
                min-width: 10.7875rem;
            }

            .success {
                margin-top: 0.6667rem;
                color: $green-main;
            }

            div.mobile-section {
                display: flex;
                justify-content: space-between;
                div.phone {
                    width: 100%;
                    padding-left: 15px;
                }
                div.phone-code {
                    width: 13rem;
                    & > div {
                        width: 100%;
                    }
                }
            }
        }
    }

    &.expanded {
        height: 90vh;
    }

    .title {
        font-size: 18 * $rem;
        margin-bottom: 40 * $rem;
        font-weight: 500;
        border-bottom: $rem solid rgb(236, 236, 236);
        padding-bottom: 20 * $rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        i {
            font-size: 28 * $rem;
            cursor: pointer;
        }
    }
}

@media only screen and (max-width: 1100px) {
    .popup {
        min-width: initial;
        width: 90%;
    }
}
</style>
